export { default } from './LegalCheckbox';
